/**
 * Servicio centralizado de API — fachada que ensambla todos los módulos de dominio
 *
 * La API pública es idéntica a la versión anterior. Los 36 consumidores que hacen
 * `import apiService from '../services/apiService'` no requieren ningún cambio.
 *
 * @module services/apiService
 * @example
 * import apiService from './services/apiService';
 * const equipos = await apiService.getEquipos({ page: 1 });
 */

import { createAuthStorage }                    from './base/authStorage';
import { createHttpClient }                     from './base/httpClient';
import { createAuthModule }                     from './modules/auth';
import { createEquiposModule }                  from './modules/equipos';
import { createOrdenesTrabajoModule }           from './modules/ordenesTrabajo';
import { createPlantillasMantenimientoModule }  from './modules/plantillasMantenimiento';
import { createProgramasModule }               from './modules/programas';
import { createAsistenciasModule }             from './modules/asistencias';
import { createCotizacionesModule }            from './modules/cotizaciones';
import { createClientesModule }               from './modules/clientes';
import { createUsuariosModule }               from './modules/usuarios';
import { createCategoriasModule }             from './modules/categorias';
import { createTiposDocumentoModule }         from './modules/tiposDocumento';
import { createUbicacionesModule }            from './modules/ubicaciones';
import { createRbacModule }                   from './modules/rbac';
import { createGaleriaModule }               from './modules/galeria';
import { createMotivosReprogramacionModule } from './modules/motivosReprogramacion';
import { createHallazgosModule }            from './modules/hallazgos';
import { createAnalyticsModule }           from './modules/analytics';
import { createNotificacionesModule }     from './modules/notificaciones';
import mutationQueue                      from './mutationQueue';

const authStorage = createAuthStorage();
const httpClient  = createHttpClient({ authStorage, mutationQueue });

const deps = {
  request:                      httpClient.request,
  authenticatedRequest:         httpClient.authenticatedRequest,
  authenticatedFormDataRequest: httpClient.authenticatedFormDataRequest
};

const apiService = {
  // baseURL expuesto para consumidores directos (downloadHelpers.js, etc.)
  ...authStorage,
  ...httpClient,
  ...createAuthModule(deps),
  ...createEquiposModule(deps),
  ...createOrdenesTrabajoModule(deps),
  ...createPlantillasMantenimientoModule(deps),
  ...createProgramasModule(deps),
  ...createAsistenciasModule(deps),
  ...createCotizacionesModule(deps),
  ...createClientesModule(deps),
  ...createUsuariosModule(deps),
  ...createCategoriasModule(deps),
  ...createTiposDocumentoModule(deps),
  ...createUbicacionesModule(deps),
  ...createRbacModule(deps),
  ...createGaleriaModule(deps),
  ...createMotivosReprogramacionModule(deps),
  ...createHallazgosModule(deps),
  ...createAnalyticsModule(deps),
  ...createNotificacionesModule(deps)
};

export default apiService;
